"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var OrderListController_js_1 = require("./OrderListController.js");
exports.OrderListController = OrderListController_js_1.OrderListController;



//////////////////
// WEBPACK FOOTER
// ./scripts/apps/order-list/controllers/index.js
// module id = 414
// module chunks = 0